import { useParams } from 'react-router-dom'
import EditHepForm from './EditHepForm'
import { useGetHepQuery } from './hepApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditHep = () => {
    useTitle('DPE: Edit HEP')

    const { id } = useParams()

    const { username, isManager, isAdmin } = useAuth()

    const { hep } = useGetHepQuery("hepList", {
        selectFromResult: ({ data }) => ({
            hep: data?.entities[id]
        }),
    })

    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!hep || !users?.length) return <PulseLoader color={"#5f788a"} />


    if (!isManager && !isAdmin) {
        if (hep.username !== username) {
            return <p className="errmsg">No access</p>
        }
    }

    const content = <EditHepForm hep={hep} users={users}  hep_id={id} />

    return content
}
export default EditHep